'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFixed = toFixed;
exports.toDecimal = toDecimal;
exports.prefixZeroForInteger = prefixZeroForInteger;
/**
 * 数据类操作
 */

/**
 * 为浮点类型的值 保留指定位数的小数点
 * @param {Number} decimal
 * @param {Number} length
 * @return {Number} decimal
 */
function toFixed(decimal, length) {
  var tempNum = 0;
  var s = void 0,
      temp = void 0,
      s1 = decimal + '';
  var start = s1.indexOf('.');

  //截取小数点后,0之后的数字，判断是否大于5，如果大于5这入为1
  if (s1.substr(start + length + 1, 1) >= 5) {
    tempNum = 1;
  }

  //计算10的len次方,把原数字扩大它要保留的小数位数的倍数
  temp = Math.pow(10, length);

  //求最接近this * temp的最小数字
  //floor() 方法执行的是向下取整计算，它返回的是小于或等于函数参数，并且与之最接近的整数
  s = Math.floor(decimal * temp) + tempNum;

  return s / temp;
}

/**
 * 将整数 转换为指定位数的小数类型
 * @param {Number} number
 * @param {Number} length
 * @return {Number} decimal
 */
function toDecimal(number, length) {
  var a = void 0,
      b = void 0,
      c = void 0,
      i = void 0;
  a = number.toString();
  b = a.indexOf('.');
  c = a.length;
  if (length == 0) {
    if (b != -1) {
      a = a.substring(0, b);
    }
  } else {
    if (b == -1) {
      a = a + '.';
      for (i = 1; i <= length; i++) {
        a = a + '0';
      }
    } else {
      a = a.substring(0, b + length + 1);
      for (i = c; i <= b + length; i++) {
        a = a + '0';
      }
    }
  }
  return a;
}

/**
 * 按照指定长度为整数首部补零
 * @param {Number} number
 * @param {Number} length
 * @return {String} number
 */
function prefixZeroForInteger(number, length) {
  return (new Array(length).join('0') + number).slice(-length);
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/data.js
// module id = 169
// module chunks = 0